import React from 'react';
import { ShieldCheck } from 'lucide-react';

export default function Attributions() {
  return (
    <div className="bg-black min-h-screen text-gray-300 pt-20 px-4 py-8">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center mb-12">
          <ShieldCheck className="w-16 h-16 mr-6 text-white" />
          <h1 className="text-5xl font-bold text-white tracking-tight">
            Attributions & Acknowledgments
          </h1>
        </div>

        <div className="space-y-8">
          <div className="bg-gray-900 p-6 rounded-lg">
            <p className="text-lg leading-relaxed mb-4">
              This product incorporates open-source software, and we acknowledge the efforts of the developers who contributed to the following projects:
            </p>

            <ul className="list-disc pl-6 space-y-2 text-lg">
              <li>
                <strong>GLFW</strong> - Jonas Bernoulli, Marcus Geelnard, and Camilla Löwy
              </li>
              <li>
                <strong>PyOpenGL</strong> - OpenGL contributors
              </li>
              <li>
                <strong>imgui-bundle</strong> - ocornut (Dear ImGui) contributors
              </li>
              <li>
                <strong>PyTorch & TorchVision</strong> - Facebook AI Research
              </li>
              <li>
                <strong>USD Core</strong> - Pixar Animation Studios
              </li>
              <li>
                <strong>FreeType</strong> - The FreeType Project
              </li>
            </ul>
          </div>

          <div className="bg-gray-900 p-6 rounded-lg">
            <h2 className="text-2xl font-semibold text-white mb-4">
              FreeType Acknowledgment
            </h2>
            <p className="italic text-lg">
              "This software uses the FreeType font rendering library."
            </p>
          </div>

          <div className="bg-gray-900 p-6 rounded-lg">
            <h2 className="text-2xl font-semibold text-white mb-4">
              Open Source Appreciation
            </h2>
            <p className="text-lg leading-relaxed">
              We deeply appreciate the contributions of all open-source developers whose work makes this product possible. Open-source software is the backbone of innovation, and we are grateful for the collaborative spirit of the global developer community.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}